import { FaSort, FaDownload } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';
import { handleError } from '../utils/errorHandler';
import { colorsRangeHex, formatNumber } from '../Transversal';
import { DEFAULT_FILTER, ArcFiltros } from '../Detalles/SesionDetalles';
import { API_URL, HEIGHT_BODY, WIDTH_RIGHT_PANEL, COLOR_FONT_TITLE } from '../Config';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { apiFetch } from '../apiClient';

let filterregrescarFiltros = 0;

class SumaGlobal {
    avancePeriodo?: number;
    cantidadNacional?: number;
    cantidadDepartamental?: number;
    cantidadMunicipal?: number;
}

interface BarraProps {
    filtrar: string;
    codigoDivipola: string;
    indicador: any
}

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const Territorial: React.FC<BarraProps> = ({ filtrar, codigoDivipola, indicador }) => {

    const [sumaGlobal, setdivipolaCantidad] = useState<SumaGlobal>();

    const fetchDatos = async () => {
        try {
            const startTime = performance.now();
            const queryString = Object.keys(DEFAULT_FILTER)
                .filter(key => DEFAULT_FILTER[key as keyof ArcFiltros] !== undefined)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros] ?? '')}`)
                .join('&');
            const url = `${API_URL}/ArcIndicador/GetSumaGlobal?${queryString}`
            const response = await apiFetch(url);
            const data = await response.json();
            const cantidadNacionalNuevo = 0;
            setdivipolaCantidad(data);
            const endTime = performance.now();
            const duration = endTime - startTime;
            console.log(`Barras Fetch duration: ${duration} ms`);
        } catch (error) {
            handleError(error);
        }
    };

    const getDatos = async () => {
        console.log(DEFAULT_FILTER);
        if (DEFAULT_FILTER.regrescarFiltros != filterregrescarFiltros) {
            filterregrescarFiltros = DEFAULT_FILTER.regrescarFiltros;
            if (indicador != "") {
                fetchDatos();
            }
        }
    }

    useEffect(() => {
        getDatos();
    }, [filtrar, codigoDivipola, indicador]);

    //const cantidadNacional = sumaGlobal?.avancePeriodo || 0;
    //const cantidadNacional = indicador.avancePeriodo || 0;
    const cantidadNacional = sumaGlobal?.cantidadNacional;
    const cantidadDepartamental = sumaGlobal?.cantidadDepartamental;
    const cantidadMunicipal = sumaGlobal?.cantidadMunicipal;
    const mostrarCantidadInternos = DEFAULT_FILTER.internos == "1"; // solo cuando no hay Dpto seleccionado

    var strCantidadNacional = "-";
    var strCantidadDepartamental = "-";
    var strCantidadMunicipal = "-";

    if (cantidadNacional !== null && cantidadNacional !== undefined) {
        strCantidadNacional = formatNumber(cantidadNacional);
    } else {
        strCantidadNacional = "-";
    }

    if (mostrarCantidadInternos) {
        strCantidadDepartamental = "-";
        strCantidadMunicipal = "-";
    }
    else {
        if (DEFAULT_FILTER.codigoDivipolaDpto === "") {
            strCantidadDepartamental = "";
        } else if (cantidadDepartamental !== null && cantidadDepartamental !== undefined) {
            strCantidadDepartamental = formatNumber(cantidadDepartamental);
        } else {
            strCantidadDepartamental = "-";
        }
    }


    if (DEFAULT_FILTER.codigoDivipolaMpio === "") {
        strCantidadMunicipal = "";
    } else if (cantidadMunicipal !== null && cantidadMunicipal !== undefined) {
        strCantidadMunicipal = formatNumber(cantidadMunicipal);
    } else {
        strCantidadMunicipal = "-";
    }

    return (
        <>
            <div style={{ textAlign: 'center', color: COLOR_FONT_TITLE, fontWeight: 'bold', fontSize: '12px' }}>Datos agregados según filtros seleccionados</div>
            <table style={{ margin: '10px auto', width: '95%', borderCollapse: 'collapse', boxShadow: '0 2px 3px rgba(0,0,0,0.1)', fontSize: '14px' }}>
                <thead>
                    <tr style={{ backgroundColor: '#f2f2f2' }}>
                        <th style={{ color: "#2c66a4", border: '1px solid #ddd', padding: '5px 0px 5px 0px', textAlign: 'center', fontWeight: 'bold', width: "33%" }}>Nacional</th>
                        <th style={{ color: "#2c66a4", border: '1px solid #ddd', padding: '5px 0px 5px 0px', textAlign: 'center', fontWeight: 'bold', width: "33%" }}>Departamento</th>
                        <th style={{ color: "#2c66a4", border: '1px solid #ddd', padding: '5px 0px 5px 0px', textAlign: 'center', fontWeight: 'bold', width: "33%" }}>Municipio</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ border: '1px solid #ddd', padding: '5px 0px 5px 0px', textAlign: 'center' }}>
                            {strCantidadNacional}
                        </td>
                        <td style={{ border: '1px solid #ddd', padding: '5px 0px 5px 0px', textAlign: 'center' }}>
                            {strCantidadDepartamental}
                        </td>
                        <td style={{ border: '1px solid #ddd', padding: '5px 0px 5px 0px', textAlign: 'center' }}>
                            {strCantidadMunicipal}
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};

export default Territorial;